import { MODAL_ACTION } from 'modules/jobManager/constants';
import { fetchJobTableDataRequest } from 'modules/jobManager/ducks/actions';
import { useCancelJobs, useJobManagerTranslations } from 'modules/jobManager/hooks';
import { ModelContextState } from 'modules/jobManager/types';
import { useDispatch } from 'react-redux';
import { Add24 } from 'ui/icons/action/Add24';
import { DestructiveButton } from 'ui/button';
import { BUTTON_SIZES } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';

export const CancelJobModal = () => {
  const { t } = useJobManagerTranslations();
  const dispatch = useDispatch();
  const { hideModal, modalState } = useModalContext<ModelContextState>();
  if (!modalState) return null;

  const [cancelJob, isCancelling] = useCancelJobs({
    id: modalState.action === MODAL_ACTION.CANCEL_JOB ? modalState.id : 0,
  });

  return (
    <Modal id="unsavedChangesModal" withPortal isModalOpen={true} onClose={hideModal}>
      <ModalHeader onClose={hideModal} autoFocus={false}>
        {t('modal.title.cancelJob')}
      </ModalHeader>
      <ModalBody>{t('modal.content.cancelJob')}</ModalBody>
      <ModalFooter onClose={hideModal}>
        <DestructiveButton
          isLoading={isCancelling}
          size={BUTTON_SIZES.LARGE}
          onClick={async () => {
            const { isSuccess } = await cancelJob();
            if (isSuccess) {
              hideModal();
              dispatch(fetchJobTableDataRequest());
            }
          }}
        >
          <Add24 />
          {t('button.cancelJob')}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
